/// <amd-module name="WorkItemsHub/Utils/WorkItemsHubTabSettings" />
import { WorkItemsHubSettingsHelper } from "Generated/Constants";
import { WorkItemsHubColumnSettings, WorkItemsHubColumnOption, WorkItemsHubSortOption } from "Generated/Contracts";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";
import { IVssPageContext } from "VSS/Platform/Context";
import { format } from "VSS/Core/Util/String";
import { UsageTelemetryHelper } from "WorkItemsHub/Utils/Telemetry";

export function updateRecentTabId(pageContext: IVssPageContext, projectId: string, tabId: string): void {
    _updateProjectScopedMeSettings(pageContext, WorkItemsHubSettingsHelper.WorkItemsHubRecentTabIdKey, tabId, projectId);
    UsageTelemetryHelper.publishChangedTabValue(pageContext, tabId);
}

export function updateColumnSettings(pageContext: IVssPageContext, projectId: string, tabId: string, columnOptions: WorkItemsHubColumnOption[], sortOptions: WorkItemsHubSortOption[], version?: number): Promise<void> {
    const columnSettings: WorkItemsHubColumnSettings = { columnOptions, sortOptions, version };

    return _updateProjectScopedMeSettings(
        pageContext,
        format(WorkItemsHubSettingsHelper.WorkItemsHubColumnSettingsKeyTemplate, tabId),
        columnSettings,
        projectId);
}

export function updateShowCompletedForTab(pageContext: IVssPageContext, projectId: string, tabId: string, showCompleted: boolean): Promise<void> {
    return _updateProjectScopedMeSettings(
        pageContext,
        format(WorkItemsHubSettingsHelper.WorkItemsHubShowCompletedKeyTemplate, tabId),
        showCompleted,
        projectId);
}

function _updateProjectScopedMeSettings<TValue>(pageContext: IVssPageContext, key: string, value: TValue, scopeValue: string): Promise<void> {
    const settingsService = pageContext.getService<ISettingsService>("ISettingsService");
    const entries: { [key: string]: any } = { [key]: value };

    return settingsService.setEntries(entries, SettingsUserScope.Me, "Project", scopeValue);
}
